import React, { useState } from 'react';
import Icon from '@components/common/assets';
import Text from '@components/common/text';
import KakaoMap from '@components/common/KakaoMap';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './map.module.scss';
const cx = classnames.bind(styles);

interface MapProps {
  positionDetail: PositionDetailVO;
}

const Map = ({ positionDetail }: MapProps) => {
  const { basicInfo } = positionDetail;
  const { address } = basicInfo;
  const [visible, setVisible] = useState(!!address);

  if (!visible) return null;

  return (
    <div className={cx('mapWrap')}>
      <div className={cx('infoArea')}>
        <div className={cx('titleArea')}>
          <Icon name="workLight" width={32} height={32} />
          <em>여기서 근무해요.</em>
        </div>
        <div className={cx('locationArea')}>
          <Icon name="pinLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
          <Text fontStyle={FontStyle.B3P_M} color={Colors.C_COOL_GRAY_70}>
            {address}
          </Text>
        </div>
      </div>
      <KakaoMap className={cx('mapArea')} address={address as string} handleError={() => setVisible(false)} />
    </div>
  );
};

export default Map;
